import auth from "../modules/auth/routes";
import customer from "../modules/customer/routes";
import company from "../modules/company/routes";
import user from "../modules/user/routes"
import profile from "../modules/profile/routes"

export default [
    ...auth,
    ...customer,
    ...company,
    ...user,
    ...profile
];



// WEBPACK FOOTER //
// ./src/routes/routes.js